import { TempoApontamento } from "./TempoApontamento";
import { BaseObj } from "./UserdataSync";

export class Apontamento extends BaseObj {
  public dia: number;
  public mes: number;
  public ano: number;

  public idConjunto: string;
  public idLei: string;

  public anotacoes: string[];
  public controleTempo: TempoApontamento[];
  public descricaoConteudo: string;

  public constructor(apontamento?: Apontamento) {
    super();
    this.idConjunto = apontamento?.idConjunto ?? "";
    this.idLei = apontamento?.idLei ?? "";
    this.anotacoes = apontamento?.anotacoes ?? new Array<string>();
    this.controleTempo =
      apontamento?.controleTempo ?? new Array<TempoApontamento>();
    this.descricaoConteudo = apontamento?.descricaoConteudo ?? "";
    const hoje = new Date();
    this.dia = apontamento?.dia ?? hoje.getDate();
    this.mes = apontamento?.mes ?? hoje.getMonth() + 1;
    this.ano = apontamento?.ano ?? hoje.getFullYear();
  }
}
